/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

export const BulkActionBar: React.LegacyFunctionComponentWithChildren<{ isActive: boolean }> = ({
  isActive,
  children,
}) => {
  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: `1px solid var(--cds-color-grey-50)`,
        borderRadius: '2px',
        padding: '9px 16px',
        background: isActive ? 'var(--cds-color-blue-700)' : 'var(--cds-color-neutral-background-primary)',
      }}
    >
      {children}
    </div>
  );
};

const Checked = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3.875" width="18" height="18" rx="1" fill="var(--cds-color-neutral-primary-invert)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1227 14.9719L7.75674 11.8385L6.7832 12.8873L11.1227 17.1489L17.7676 9.8321L16.7454 8.64453L11.1227 14.9719Z"
        fill="var(--cds-color-blue-700)"
      />
    </svg>
  );
};
const Unchecked = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1" fill="var(--cds-color-neutral-primary-invert)">
        <rect x="3" y="3.875" width="18" height="18" rx="1" />
      </mask>
      <rect
        x="3"
        y="3.875"
        width="18"
        height="18"
        rx="1"
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-grey-500)"
        strokeWidth="3"
        mask="url(#path-1-inside-1)"
      />
    </svg>
  );
};
type Props = React.InputHTMLAttributes<HTMLInputElement>;

export const BulkActionBarCheckbox = (props: Props) => {
  const [focused, setFocused] = React.useState(false);

  const Icon = props?.checked ? Checked : Unchecked;
  return (
    <div
      css={[
        { position: 'relative', lineHeight: 1 },
        focused && {
          outline: '5px auto -webkit-focus-ring-color',
          outlineOffset: '0px',
        },
      ]}
    >
      <Icon />
      <input
        type="checkbox"
        {...props}
        css={{
          opacity: 0,
          position: 'absolute',
        }}
        onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
          setFocused(true);
          props?.onFocus?.(event);
        }}
        onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
          setFocused(false);
          props?.onBlur?.(event);
        }}
      />
    </div>
  );
};
